import { t as e } from "./cx-BjmrJCen.js";
/* empty css                              */
/* empty css                             */
import { jsx as t, jsxs as n } from "react/jsx-runtime";
//#region src/components/field/field.css.ts
var r = "_8jerxi0", i = "_8zp7se1";
//#endregion
//#region src/components/field/field.tsx
function a({ children: a, className: o, htmlFor: s, label: c, ...l }) {
	return /* @__PURE__ */ n("div", {
		...l,
		className: e(r, o),
		children: [/* @__PURE__ */ t("label", {
			className: i,
			htmlFor: s,
			children: c
		}), a]
	});
}
//#endregion
export { a as Field };

//# sourceMappingURL=field.js.map